'use client'

import Link from '@components/primitives/Link'
import { Text } from '@components/primitives/Text'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import type { HospitalPageData } from '@modules/hospitals/cache/getCachedHospitalPageData'
import { Suspense, useState } from 'react'
import HospitalMap from './HospitalMap/HospitalMap.client'

export const NearbyHospitalsSection = ({
  hospitalPageData,
}: {
  hospitalPageData: HospitalPageData
}) => {
  const [hoveredHospitalSlug, setHoveredHospitalSlug] = useState<
    string | undefined
  >()

  return (
    <section className='mt-16'>
      <Text className='mb-4' element='h3' styleName='h4'>
        Similar Hospitals nearby
      </Text>
      <div className='flex flex-col overflow-hidden rounded-xl border border-neutral200 md:flex-row'>
        <div className='flex w-full flex-col gap-1 p-6 md:w-1/2'>
          <Text styleName='h4'>Select from list below to view details</Text>

          <div>
            {hospitalPageData.similarHospitalsNearby.map((hospital) => (
              <div
                className='border-b border-neutral200 p-2 last:border-none hover:bg-neutral100'
                key={hospital.slug}
                onMouseEnter={() => setHoveredHospitalSlug(hospital.slug)}
                onMouseLeave={() => setHoveredHospitalSlug(undefined)}
              >
                <Link href={DynamicRoutes.center(hospital.slug)}>
                  <Text styleName='p-strong'>{hospital.name}</Text>
                  <Text className='text-neutral600' styleName='p-small'>
                    {hospital.trialCount?.toLocaleString() ?? 'Researching'}{' '}
                    trials
                  </Text>
                </Link>
              </div>
            ))}
          </div>
        </div>
        <div className='w-full flex-col gap-6 md:flex md:w-1/2'>
          {hospitalPageData.zipcode && (
            <Suspense fallback={'Loading...'}>
              <HospitalMap
                hospitals={hospitalPageData.similarHospitalsNearby}
                hoveredHospitalSlug={hoveredHospitalSlug}
                nearestPoint={hospitalPageData.zipcode}
                setHoveredHospitalSlug={setHoveredHospitalSlug}
              />
            </Suspense>
          )}
        </div>
      </div>
    </section>
  )
}
